export default __webpack_public_path__ + "de0627cc53132489dec2b71512c2398f.svg";